import { asyncRoutes, constantRoutes } from '@/router'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    if (roles.some(role => role === '@all')) {
      if (route.meta.roles.some(role => role.indexOf('cu_') === 0)) {
        return false
      } else {
        return true
      }
    }
    return route.meta.roles.some(menu_role => roles.some(root_role => root_role.indexOf(menu_role) === 0))
    // return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise(resolve => {
      const accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
      // Louis 处理工单菜单下没有子菜单的情况 start。20211110
      var delRouter = null
      for (const router of accessedRoutes) {
        if (router.path === '/work_order' && router.children.length === 0) {
          delRouter = router
        }
      }
      if (delRouter != null) {
        accessedRoutes.splice(accessedRoutes.indexOf(delRouter), 1)
      }
      // Louis 处理工单菜单下没有子菜单的情况 end。20211110

      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
